import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {MetricDefinitionBO} from "./MetricDefinition.BO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";

export class MetricDefinitionBOAudit {


    static async MetricDefinitionAuditBO(MetricDefinitionBO: MetricDefinitionBO): Promise<AuditService> {
        const self = MetricDefinitionBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("MetricDefinition", self.drWB_MetricDefinition.cif.WB_MTRDFN_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const metricDefinitionParams: IAuditField [] = [
            {fieldName: "METRIC_ID",              realName: "ID"}, //create
            {fieldName: "METRIC_NAME",                realName: "Name" }, //create
            {fieldName: "METRIC_TYPE",  realName: "Metric Type", domainId: "Metric_Type"},
            {fieldName: "MANUAL_IND",        realName: "Manual"},
            {fieldName: "WB_SUBJECTAREA_ID",          realName: "Subject Area ID"},
            {fieldName: "SUBJECTAREA_COLUMNNAME",         realName: "SubjectArea Column"},
            {fieldName: "FILTER_OPTIONS",       realName: "Filter Options"},
            {fieldName: "METRIC_FORMAT",         realName: "Metric Format"},
            {fieldName: "CURRENCY_IND",              realName: "Currency Ind"},
            {fieldName: "GL_ACCOUNT_FILTER_IND",                realName: "GL Account Filter"},
            {fieldName: "EVTS_TYPE_FILTER_IND",  realName: "Spend Type Filter"},
            {fieldName: "FORMULA",        realName: "Formula"},
            {fieldName: "METRIC_USAGE",          realName: "Metric Usage"},
            {fieldName: "OPTIONS",         realName: "Options"},
            {fieldName: "TOTAL_FORMULA",       realName: "Total Formula"},
            {fieldName: "METRIC_DATATYPE",         realName: "Metric Datatype",domainId: "Metric_Datatype"},
            {fieldName: "EDITABLE_IND",              realName: "Editable" },
            {fieldName: "RECORD_PROPERTIES",                realName: "Record Properties" },
            {fieldName: "MINVALUE",                      realName: "MINVALUE" },
            {fieldName: "MAXVALUE",                      realName: "MAXVALUE" },
            {fieldName: "TOTAL_AGGREGATION_TERMS",          realName: "Total Aggregration Terms"},
            {fieldName: "COPYPOLICY",         realName: "Copy Policy"},
            {fieldName: "TOTALPOLICY",       realName: "Total Policy"},
            {fieldName: "SCENARIO_COLUMNNAME", realName:"Field Name "}

        ]

        // Metric Definition GL Account Rows
        const metricDefinitionGLAccountParams: IAuditField [] = [
            {fieldName: "GLACCOUNT_ID",          realName: "Account ID" },
            {fieldName: "GLACCOUNT_NAME",    realName: "Account Name" },

        ]

        // Event Spend Type Rows
        const spendTypeParams: IAuditField [] = [
            {fieldName: "SPENDTYPE_ID",        realName: "Type ID" },
            {fieldName: "SPEND_TYPE_NAME",        realName: "Type Name" },

        ]



        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_MetricDefinition, metricDefinitionParams, {objectName: 'MetricDefinition', deletedKeys: deleteKeys})

        // TPM Event Type Rows
        for(let aRow of self.drWB_MetricDefinition.WB_MetricDefinitionGLAccountRows) {
            await AuditUtils.logRecord(auditService, aRow, metricDefinitionGLAccountParams,{objectName: 'GL Account', deletedKeys: deleteKeys})
        }

        // Event Spend Rows
        for(let aEventSpendRow of self.drWB_MetricDefinition.WB_MetricDefinitionEventSpendRows) {
            // let bLogInsertDeltes = aTPMPrdRow.cif.ROW_TYPE === 'Display'
            await AuditUtils.logRecord(auditService, aEventSpendRow, spendTypeParams,{objectName: 'Event Spend Type', deletedKeys: deleteKeys})
        }


        return auditService
    }



}
